import { appConfig } from './../config'
import { ConfigsType } from '../config'
import Material from './Material'
import { ShapeUtils, Vector2 } from 'three'

type PLengthPropsType = {
    type: 'parametric_length'
    length: { value: number, extra: number }
    formula: 'mult'
}

type PAreaPropsType = {
    type: 'parametric_area'
    width: { value: number, extra: number }
    length: { value: number, extra: number }
    extra: number
    formula: 'mult'
}

type PCornerHorizontalSheetPropsType = {
    type: 'parametric_cornerHorizontalSheet'
    subType: '2door' | 'angle'
    width1: { value: number, extra: number }
    width2: { value: number, extra: number }
    depth1: { value: number, extra: number }
    depth2: { value: number, extra: number }
    backWidth1: { value: number, extra: number }
    backWidth2: { value: number, extra: number }
    thickness: { value: number, extra: number }
    // extra: number
    formula: 'mult'
}

type PCornerTwoDoorPropsType = {
    type: 'parametric_cornerTwoDoor'
    width1: { value: number, extra: number }
    width2: { value: number, extra: number }
    height: { value: number, extra: number }
    // extra: number
    formula: 'mult'
}

type PCountPropsType = {
    type: 'parametric_count'
    count: { value: number, extra: number }
    formula: 'mult'
}

type PDrawerBoxPropsType = {
    type: 'parametric_drawerBox'
    height: { value: number, extra: number }
    width: { value: number, extra: number }
    depth: { value: number, extra: number }
    formula: 'mult'
}

type PHingePropsType = {
    type: 'parametric_hinge'
    count: { value: number, extra: number }
    height: { value: number, extra: number }
    formula: 'mult'
}

// type ParamsTypes = MeterParamsType | AreaParamsType | CountParamsType
export const hardwareParamTypeValues = ['length', 'area', 'count', 'drawerBox', 'cornerHorizontalSheet', 'cornerTwoDoor', 'hinge']

// type ParametricPropsType = {
//     type: 'parametric',
//     params: ParamsTypes
// }

type StaticPropsType = {
    type: 'static'
}

type PropsType = StaticPropsType | PLengthPropsType | PAreaPropsType | PCountPropsType | PDrawerBoxPropsType | PCornerHorizontalSheetPropsType | PCornerTwoDoorPropsType | PHingePropsType

type ParamType = { [key: string]: { value: number, extra: number } }

export const getHardwareParams = (hardware: Hardware) => {

    if (hardware.props.type === 'static') {
        return [] as ParamType[]
    }
    else if (hardware.props.type === 'parametric_length') {
        return [{ length: hardware.props.length }] as ParamType[]
    }
    else if (hardware.props.type === 'parametric_area') {
        return [{ length: hardware.props.length }, { width: hardware.props.width }] as ParamType[]
    }
    else if (hardware.props.type === 'parametric_count') {
        for (const key in hardware.props) {
            if (key.split('_')[0] === 'count') {
                // @ts-ignore
                return [{ count: hardware.props[key] }] as ParamType[]
            }
        }
        return [{ count: hardware.props.count }] as ParamType[]//this line must never works
    }
    else if (hardware.props.type === 'parametric_cornerHorizontalSheet') {
        return [
            // { subType: hardware.props.subType },
            { width1: hardware.props.width1 },
            { width2: hardware.props.width2 },
            { depth1: hardware.props.depth1 },
            { depth2: hardware.props.depth2 },
            { backWidth1: hardware.props.backWidth1 },
            { backWidth2: hardware.props.backWidth2 },
            { thickness: hardware.props.thickness }
        ]
    }
    else if (hardware.props.type === 'parametric_cornerTwoDoor') {
        return [
            { width1: hardware.props.width1 },
            { width2: hardware.props.width2 },
            { height: hardware.props.height }
        ]
    }
    else if (hardware.props.type === 'parametric_hinge') {
        return [
            { height: hardware.props.height },
            { count: hardware.props.count },
        ]
    }
    else {//if (hardware.props.type === 'parametric_drawerBox') {
        return [{ height: hardware.props.height }, { width: hardware.props.width }, { depth: hardware.props.depth }] as ParamType[]
    }
}

export type HardwareTypes = 'static' | 'parametric_length' | 'parametric_area' | 'parametric_count' | 'parametric_drawerBox' | 'parametric_cornerHorizontalSheet' | 'parametric_cornerTwoDoor' | 'parametric_hinge'

export type HardwareProps = {
    name: string
    sku: string
    description: string
    type: HardwareTypes
    unitWeight: number
    unitPrice: number
    unitPriceAddon: number
    addonD: number
    addonP: number
    minPrice: number
    markupId: number
    materialsIds: string[]
    defaultMaterialId: number
    childrenIds: number[]
    editable: string//0 or 1
}

export default class Hardware {

    id: number
    localId: number
    name: string
    type: HardwareTypes
    unitWeight: number
    unitPrice: number
    unitPriceAddon: number
    addonD: number
    addonP: number
    minPrice: number
    markupValue: number

    materialBased: boolean
    drawerConfig: ConfigsType['drawerConfig']
    hingeBreakpoints: ConfigsType['hingeBreakpoints']

    props: PropsType

    count = 1
    weight = 0
    price = 0
    clearPrice = 0
    nonMarkupPrice = 0

    material: Material | undefined
    children: Hardware[]

    constructor(hProp: { id: number, localId: number, count: number }, name: string, type: HardwareTypes, unitWeight: number, unitPrice: number, unitPriceAddon: number, addonD: number, addonP: number, minPrice: number, markupValue: number, material: Material | undefined = undefined, children: Hardware[] = [], drawerConfig: ConfigsType['drawerConfig'], hingeBreakpoints: ConfigsType['hingeBreakpoints']) {
        this.id = hProp.id
        this.localId = hProp.localId
        this.count = hProp.count
        this.name = name
        this.type = type
        this.unitWeight = unitWeight
        this.unitPrice = unitPrice
        this.unitPriceAddon = unitPriceAddon
        this.addonD = addonD
        this.addonP = addonP
        this.minPrice = minPrice
        this.markupValue = markupValue
        this.material = material
        this.children = children
        this.drawerConfig = drawerConfig
        this.hingeBreakpoints = hingeBreakpoints

        //better conditioning must be
        if (this.unitPrice === -1)
            this.materialBased = true
        else
            this.materialBased = false

        this.props = this.generateProps()
        this.calculatePrice()
    }

    generateProps = (): PropsType => {
        if (this.type === 'static') {
            return {
                type: this.type
            } as StaticPropsType
        }
        else if (this.type === 'parametric_length') {
            return {
                type: this.type,
                length: { value: 1, extra: 0 },
                formula: 'mult'
            } as PLengthPropsType
        }
        else if (this.type === 'parametric_area') {
            return {
                type: this.type,
                width: { value: 1, extra: 0 },
                length: { value: 1, extra: 0 },
                extra: 0,
                formula: 'mult'
            } as PAreaPropsType
        }
        else if (this.type === 'parametric_count') {
            return {
                type: this.type,
                count: { value: 1, extra: 0 },
                formula: 'mult'
            } as PCountPropsType
        }
        else if (this.type === 'parametric_cornerHorizontalSheet') {
            return {
                type: this.type,
                subType: 'angle',
                width1: { value: 1, extra: 0 },
                width2: { value: 1, extra: 0 },
                depth1: { value: 1, extra: 0 },
                depth2: { value: 1, extra: 0 },
                backWidth1: { value: 1, extra: 0 },
                backWidth2: { value: 1, extra: 0 },
                thickness: { value: 1, extra: 0 },
                // extra: number
                formula: 'mult'
            }
        }
        else if (this.type === 'parametric_cornerTwoDoor') {
            return {
                type: this.type,
                width1: { value: 1, extra: 0 },
                width2: { value: 1, extra: 0 },
                height: { value: 1, extra: 0 },
                // extra: number
                formula: 'mult'
            }
        }
        else if (this.type === 'parametric_hinge') {
            return {
                type: this.type,
                height: { value: 1, extra: 0 },
                count: { value: 1, extra: 0 },
                // extra: number
                formula: 'mult'
            }
        }
        else {// if (this.type === 'parametric_drawerBox') {
            return {
                type: this.type,
                height: { value: 10.16, extra: 0 },
                width: { value: 58.42, extra: 0 },
                depth: { value: 50.165, extra: 0 },
                formula: 'mult'
            } as PDrawerBoxPropsType
        }
    }

    calculatePrice = () => {

        const unitPrice = this.materialBased && this.material ? this.material.price + this.material.addon : this.unitPrice
        const clearUnitPrice = this.materialBased && this.material ? this.material.price : this.unitPrice
        const unitWeight = this.materialBased && this.material ? this.material.weight : this.unitWeight

        if (this.props.type === 'static') {
            this.price = unitPrice //* this.count
            this.clearPrice = clearUnitPrice //* this.count
            this.weight = unitWeight
        }
        else if (this.props.type === 'parametric_length') {
            const length = this.props.length

            this.price = unitPrice * (length.value + length.extra)
            this.clearPrice = clearUnitPrice * (length.value + length.extra)
            this.weight = unitWeight * (length.value + length.extra)
        }
        else if (this.props.type === 'parametric_area') {
            const height = this.props.length
            const width = this.props.width
            const extraArea = this.props.extra

            this.clearPrice = clearUnitPrice * ((height.value + height.extra) * (width.value + width.extra) + extraArea)
            this.weight = unitWeight * ((height.value + height.extra) * (width.value + width.extra) + extraArea)

            this.price = unitPrice * ((height.value + height.extra) * (width.value + width.extra) + extraArea)
            const machiningCost = (this.unitPriceAddon * ((height.value + height.extra) * (width.value + width.extra) + extraArea) + this.addonD) * (1 + 0.01 * this.addonP)
            this.price = Math.max(this.minPrice, this.price + machiningCost)
        }
        else if (this.props.type === 'parametric_count') {
            let count = { value: 0, extra: 0 }

            for (const key in this.props) {
                if (key.split('_')[0] === 'count') {
                    // @ts-ignore
                    count = this.props[key]
                }
            }

            this.price = unitPrice * (count.value + count.extra)
            this.clearPrice = clearUnitPrice * (count.value + count.extra)
            this.weight = unitWeight * (count.value + count.extra)
        }
        else if (this.props.type === 'parametric_cornerHorizontalSheet') {

            // const e1 = this.props.width1.value - this.props.backWidth1.value - this.props.thickness.value //old backWidth calculation, some calculations can be useless now, but for fast reaching result algorithm not been changed
            const e1 = this.props.backWidth1.value - this.props.thickness.value
            const e2 = this.props.backWidth2.value - this.props.thickness.value
            const hyp = (e1 ** 2 + e2 ** 2) ** .5
            const x1 = (this.props.thickness.value) * hyp / e2
            const x2 = (this.props.thickness.value) * hyp / e1

            const points = []

            points.push(new Vector2(this.props.backWidth2.value + x2, this.props.thickness.value))
            points.push(new Vector2(this.props.width2.value - this.props.thickness.value, this.props.thickness.value))
            points.push(new Vector2(this.props.width2.value - this.props.thickness.value, this.props.depth2.value))

            if (this.props.subType === '2door')
                points.push(new Vector2(this.props.depth1.value, this.props.depth2.value))

            points.push(new Vector2(this.props.depth1.value, this.props.width1.value - this.props.thickness.value))
            points.push(new Vector2(this.props.thickness.value, this.props.width1.value - this.props.thickness.value))
            points.push(new Vector2(this.props.thickness.value, this.props.backWidth1.value + x1))

            const area = ShapeUtils.area(points)

            this.weight = area * unitWeight
            this.clearPrice = area * clearUnitPrice

            this.price = area * unitPrice
            const machiningCost = (this.unitPriceAddon * area + this.addonD) * (1 + 0.01 * this.addonP)
            this.price = Math.max(this.minPrice, this.price + machiningCost)
        }
        else if (this.props.type === 'parametric_cornerTwoDoor') {

            const area = (this.props.width1.value + this.props.width2.value) * this.props.height.value

            this.weight = area * unitWeight
            this.clearPrice = area * clearUnitPrice

            this.price = area * unitPrice
            const machiningCost = (this.unitPriceAddon * area + this.addonD) * (1 + 0.01 * this.addonP)
            this.price = Math.max(this.minPrice, this.price + machiningCost)
        }
        else if (this.props.type === 'parametric_drawerBox') {
            const sidesCost = 2 * (this.props.depth.value + this.props.depth.extra) * unitPrice
            const frontAndBackCost = 2 * (this.props.width.value + this.props.width.extra) * unitPrice
            const bottomCost = (this.props.depth.value + this.props.depth.extra) * (this.props.width.value + this.props.width.extra) * this.drawerConfig.boxBottomMaterialPrice
            const labor = [5.08, 7.62, 10.16].includes((this.props.height.value + this.props.height.extra)) ? this.drawerConfig.boxLaborPrice[0] : this.drawerConfig.boxLaborPrice[1]

            const clearSidesCost = 2 * (this.props.depth.value + this.props.depth.extra) * clearUnitPrice
            const clearFrontAndBackCost = 2 * (this.props.width.value + this.props.width.extra) * clearUnitPrice
            const clearBottomCost = (this.props.depth.value + this.props.depth.extra) * (this.props.width.value + this.props.width.extra) * this.drawerConfig.boxBottomMaterialPrice

            this.price = sidesCost + frontAndBackCost + bottomCost + labor
            this.clearPrice = clearSidesCost + clearFrontAndBackCost + clearBottomCost + labor

            //Calculate sum of sheets' areas
            const width = this.props.width.value + this.props.width.extra
            const height = this.props.height.value + this.props.height.extra
            const depth = this.props.depth.value + this.props.depth.extra

            const area = (depth * width) + 2 * (depth * height) + 2 * (width * height)

            this.weight = unitWeight * area
        }
        else if (this.props.type === 'parametric_hinge') {
            const breakpoints = this.hingeBreakpoints.array.split(',').map(num => parseFloat(num.trim())).sort((a, b) => a - b)
            let count = 2

            for (const bp of breakpoints) {
                if (this.props.height.value > bp)
                    count++
                else
                    break
            }

            this.props.count.value = count

            this.price = unitPrice * this.props.count.value
            this.clearPrice = clearUnitPrice * this.props.count.value
            this.weight = unitWeight * this.props.count.value
        }

        this.nonMarkupPrice = this.price

        //Multiply price by markup
        this.price = this.price * this.markupValue

        //Sum prices of children
        if (this.children.length > 0) {
            this.children.forEach(child => {
                child.calculatePrice()
                this.price += child.price
                this.clearPrice += child.clearPrice
                this.nonMarkupPrice += child.nonMarkupPrice
            })
        }

        //Multiply price by count
        this.weight *= this.count
        this.price *= this.count
        this.clearPrice *= this.count
        this.nonMarkupPrice *= this.count

        //Fix js problem of float numbers
        this.weight = parseFloat(this.weight.toFixed(appConfig.fractionDigits))
        this.price = parseFloat(this.price.toFixed(appConfig.fractionDigits))
        this.clearPrice = parseFloat(this.clearPrice.toFixed(appConfig.fractionDigits))
        this.nonMarkupPrice = parseFloat(this.nonMarkupPrice.toFixed(appConfig.fractionDigits))
    }

    updateProps = (props: PropsType) => {
        this.props = props
        this.calculatePrice()
    }

    // changeCount = (count: number) => {
    //     this.count = count
    //     this.calculatePrice()
    // }

}
